import { render } from "./IconButton.vue?vue&type=template&id=5db214ea&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=5db214ea&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db214ea"]])

export default __exports__